import { DialogService } from '@/infrastructure/utils/util-services/dialog-service/types/dialog-service.interface';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import Vue from 'vue';
import { useDisposes } from './use-disposes';
import { Disposable } from '@patsnap/tahiti-core/common/disposable';
import { useI18n } from '@/presentation/composables/common/use-i18n';
import { useRouter } from 'vue-router/composables';
export const useDialog = () => {
    const { disposes } = useDisposes();
    const router = useRouter();
    const { i18n } = useI18n();
    const createDialog = (component, props) => {
        const dialogService = injectService(DialogService);
        let dialogApp = new Vue({
            render: h => h(component, { props }),
            // @ts-ignore
            router,
            // @ts-ignore
            i18n,
        }).$mount();
        disposes.push(Disposable.create(() => {
            dialogService.close();
            dialogApp = null;
        }));
        return dialogService.init(dialogApp);
    };
    return {
        createDialog,
    };
};
